<div class="scroll-area">
    <div class="install-body">
        <div class="tab-content">

            <div class="g_foto-boxes-container top-photos-container">
                <app-image-input
                        label="Foto Installationsbox*"
                        name="photoInstallationBox"
                        [imageQuality]="LOW_IMAGE_QUALITY"
                        required
                        [(ngModel)]="model.installationBoxImage">
                </app-image-input>

                <app-image-input
                        label="Foto Antenne*"
                        name="photoAntenna"
                        [imageQuality]="LOW_IMAGE_QUALITY"
                        required
                        [(ngModel)]="model.antennaImage">
                </app-image-input>

                <app-image-input [resizeImage]="false"
                                 label="Foto Heizungsschema*"
                                 name="heatingSchemeImage"
                                 required
                                 [(ngModel)]="model.schemeImage">
                </app-image-input>

                <app-image-input
                        label="Foto Sammler"
                        name="heatingCollectorImage"
                        [imageQuality]="LOW_IMAGE_QUALITY"
                        [(ngModel)]="model.heatingCollectorImage">
                </app-image-input>
            </div>

            <div class="g_foto-boxes-container top-photos-container">
                <app-image-input *ngIf="model?.postInstallBoilerRoomImages[0]"
                                 label="Heizkeller 1*"
                                 name="post_install_boiler_room_image_1"
                                 required
                                 [(ngModel)]="model.postInstallBoilerRoomImages[0].image">
                </app-image-input>

                <app-image-input *ngIf="model?.postInstallBoilerRoomImages[1]"
                                 label="Heizkeller 2*"
                                 name="post_install_boiler_room_image_2"
                                 required
                                 [(ngModel)]="model.postInstallBoilerRoomImages[1].image">
                </app-image-input>

                <app-image-input *ngIf="model?.postInstallBoilerRoomImages[2]"
                                 label="Heizkeller 3*"
                                 name="post_install_boiler_room_image_3"
                                 required
                                 [(ngModel)]="model.postInstallBoilerRoomImages[2].image">
                </app-image-input>
            </div>

            <div class="g_foto-boxes-container top-photos-container">
                <ng-container *ngFor="let image of model.postInstallHeatingImages, let i = index">
                    <app-image-input *ngIf="i < prePhotos.preInstallHeatingImages.length - 1"
                                     [label]="'Foto Steuerung ' + (i + 1) + '*'"
                                     [name]="'post_install_heating_image_' + (i + 1)"
                                     [(ngModel)]="image.image"
                                     required
                                     (ngModelChange)="updateHeatingImages($event, i)">
                    </app-image-input>
                    <app-image-input *ngIf="i >= prePhotos.preInstallHeatingImages.length - 1"
                                     [label]="'Foto Steuerung ' + (i + 1)"
                                     [name]="'post_install_heating_image_' + (i + 1)"
                                     [(ngModel)]="image.image"
                                     (ngModelChange)="updateHeatingImages($event, i)">
                    </app-image-input>

                </ng-container>
            </div>
        </div>
    </div>
</div>
<app-navigation-footer
        [isBackLinkDisabled]="false"
        [backLink]="'/gateway/sensors/other'"
        [isNextLinkDisabled]="!validationService.isAllDataValid()"
        [nextLink]=""
        [isLast]="true"
></app-navigation-footer>
